export function DownloadIcon({ fill = "#4aa5ff" }: { fill?: string }) {
  return (
    <svg
      tabIndex={-1}
      focusable="false"
      className="icon-download"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        className="primary-path"
        d="
                    M19.35 7.04C18.67 3.59 15.64 1 12 1C9.11 1 6.6 2.64 5.35 5.04C2.34 5.36 0 7.91 0 11C0 14.31 2.69 17
                    6 17H8C8.55229 17 9 16.5523 9 16C9 15.4477 8.55228 15 8 15H6C3.79 15 2 13.21 2 11C2 8.79 3.79 7 6
                    7H6.71C7.37 4.69 9.48 3 12 3C15.04 3 17.5 5.46 17.5 8.5V9H19C20.66 9 22 10.34 22 12C22 13.66 20.66
                    15 19 15H16C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17H19C21.76 17 24 14.76 24 12C24
                    9.36 21.95 7.22 19.35 7.04ZM12.4182 23.7152C12.2202 23.9444 11.8657 23.9464 11.6653 23.7196L8.2595
                    19.8681C7.88011 19.4391 7.92161 18.7849 8.35203 18.4068C8.78269 18.0288 9.43919 18.0701 9.81858
                    18.4991L11 19.8353L11 11.0001C11 10.4478 11.4477 10.0001 12 10.0001C12.5522 10.0001 13 10.4478 13
                    11.0001L13 19.8671L14.1736 18.5083C14.5478 18.0749 15.2038 18.0259 15.6386 18.3989C16.0737 18.7719
                    16.1228 19.4256 15.7485 19.859L12.4182 23.7152Z
                "
        fill={fill}
      />
    </svg>
  );
}
